// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iXBq2gtAJjprCi {
  word-break: break-word;
}
.yTfR1hi7LtbTiU {
  display: none;
}
.iXBq2gtAJjprCi:hover .yTfR1hi7LtbTiU {
  display: inline-block;
}
.TBi2lo28NTUY_y {
  display: flex;
}
.YpyEqPJF7sZ23j {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.YpyEqPJF7sZ23j:hover {
  color: var(--ds-text-subtle, #44546f);
}
.JoirXEKfl9xfjm div[role='button'] > a > img {
  max-width: 100%;
}
`, ""]);
// Exports
export var wrapper = `iXBq2gtAJjprCi`;
export var copyLinkWrapper = `yTfR1hi7LtbTiU`;
export var descriptionWrapper = `TBi2lo28NTUY_y`;
export var replyButton = `YpyEqPJF7sZ23j`;
export var boardActionWrapper = `JoirXEKfl9xfjm`;
export default ___CSS_LOADER_EXPORT___;
